import React from "react";
import PropTypes from "prop-types";
import { Slider } from "antd";
import "./FeedbackSlider.css";

const PINK_PRIMARY = "#FE5F7B";
const PINK_LIGHT = "rgba(254, 95, 123, 0.25)";
const PINK_RAIL = "rgba(254, 95, 123, 0.12)";

/**
 * Reusable feedback rating slider with pink theme.
 * Props:
 * - min, max: number range (e.g. 0-10 or 1-5)
 * - leftLabel, rightLabel: text below slider (e.g. "Not at all likely" / "Extremely likely" or "Strongly disagree" / "Strongly agree")
 * - value, onChange, disabled: for Form control
 */
const FeedbackSlider = ({
  min = 0,
  max = 10,
  leftLabel = "",
  rightLabel = "",
  value,
  onChange,
  disabled = false,
}) => {
  const count = max - min + 1;
  const marks =
    count <= 11 ? Array.from({ length: count }, (_, i) => min + i) : [];

  return (
    <div className="w-full px-1 py-0">
      <div
        className=" flex justify-between items-center w-full px-1 py-0 mb-[-2px] box-border"
        aria-hidden="true"
      >
        {marks.map((num) => (
          <span
            key={num}
            className="flex-none w-6 text-center text-sm text-[#666666] leading-none"
          >
            {num}
          </span>
        ))}
      </div>
      <Slider
        min={min}
        max={max}
        step={1}
        marks={false}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="feedback-slider"
        trackStyle={{
          background: `linear-gradient(to right, ${PINK_LIGHT}, ${PINK_PRIMARY})`,
        }}
        railStyle={{ background: PINK_RAIL }}
        handleStyle={{
          borderColor: PINK_PRIMARY,
          backgroundColor: PINK_PRIMARY,
        }}
      />
      {(leftLabel || rightLabel) && (
        <div className="flex justify-between mt-1 px-0.5 text-xs text-[#6c757d] ">
          <span>{leftLabel}</span>
          <span>{rightLabel}</span>
        </div>
      )}
    </div>
  );
};

FeedbackSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FeedbackSlider;
